import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import {
  Aangifte,
  BokkzAlgDataService,
  IncomeTaxEntity,
  JaarrekeningVenW
} from "@snelstart-ventures/fiscaal/domain-logic";
import { FormArray, FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import { BehaviorSubject, filter, Subscription } from "rxjs";
import { Event, NavigationEnd, Router } from "@angular/router";
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-resultaat-uit-overige-werkzaamheden',
  templateUrl: './resultaat-uit-overige-werkzaamheden.component.html',
  styleUrls: ['./resultaat-uit-overige-werkzaamheden.component.scss'],
  imports: [
    SharedUiDetailsModule,
    ReactiveFormsModule,
    SharedUiFormControlsModule,
    SharedUiButtonModule,
    CommonModule
  ]
})

export class ResultaatUitOverigeWerkzaamhedenComponent implements OnInit, OnDestroy {
    private routerSubscription: Subscription | undefined;
    private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
    private isDefAangifteSubscription: Subscription | undefined;

    private isSaving = false;
    public clientId!: string;
    @Input() public id!: string;
    aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;

    public partnerBoolean = {} as boolean;
    @Input() partner = new BehaviorSubject<boolean>(false);
    private partnerAangifte = {} as Aangifte

    public isDefAangifte = {} as boolean;

    private focusedElementId: string | null = null;

    public showSpinner = true;

    public rowTotaalFg = {} as FormGroup

    constructor(
        public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService,
        private router: Router,
        private fb: FormBuilder) {
        this.rowTotaalFg = this.fb.group({
            rowOpbrengsten: this.fb.array<JaarrekeningVenW>([]),
            rowKosten: this.fb.array<JaarrekeningVenW>([])
        });
    }

    get rowOpbrengsten(): FormArray {
        return this.rowTotaalFg.get('rowOpbrengsten') as FormArray;
    }

    get rowKosten(): FormArray {
        return this.rowTotaalFg.get('rowKosten') as FormArray;
    }

    addRijRowOpbrengsten(): void {
        this.rowOpbrengsten.push(this.createRowGroup())
    }

    addRijRowKosten(): void {
        this.rowKosten.push(this.createRowGroupKosten())
    }

    verwijderRijRowOpbrengsten(index: number): void {
        this.rowOpbrengsten.removeAt(index);
        this.rowTotaalFg.updateValueAndValidity()
        this.rowTotaalFg.markAsDirty()
        this.saveForm();
    }

    verwijderRijRowKosten(index: number): void {
        this.rowKosten.removeAt(index);
        this.rowTotaalFg.updateValueAndValidity()
        this.rowTotaalFg.markAsDirty()
        this.saveForm();
    }


    createRowGroup(jaarrekeningVenW?: JaarrekeningVenW): FormGroup {
        return this.fb.group(({
            omschrijving: jaarrekeningVenW ? jaarrekeningVenW.omschrijving : undefined,
            bedrag: jaarrekeningVenW ? jaarrekeningVenW.bedrag : undefined,
            kostensoort: jaarrekeningVenW ? jaarrekeningVenW.kostensoort : undefined,
        } as JaarrekeningVenW))
    }

    createRowGroupKosten(jaarrekeningVenW?: JaarrekeningVenW): FormGroup {
        return this.fb.group(({
            omschrijving: jaarrekeningVenW ? jaarrekeningVenW.omschrijving : undefined,
            bedrag: jaarrekeningVenW ? jaarrekeningVenW.bedrag : undefined,
            kostensoort: jaarrekeningVenW ? jaarrekeningVenW.kostensoort : undefined,
        } as JaarrekeningVenW))
    }

    public ngOnInit(): void {
       this.isDefAangifteSubscription =  this.dataService.isDefAangifte.subscribe((isDefAangifte) => {
            this.isDefAangifte = isDefAangifte;
        })
       this.incomeTaxEntitySubscription = this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                const aangifte = incomeTaxEntity.aangifte;
                this.aangifte = aangifte;
                this.partnerAangifte = aangifte.partnerAangifte ? aangifte.partnerAangifte : {} as Aangifte;
                this.updateForm();
                this.partner.subscribe((partner) => {
                    this.partnerBoolean = partner
                    this.rowTotaalFg.reset()
                    this.updateForm();
                });
            }
        });
      this.clientEntitySubscription = this.dataAlgService.client.subscribe((client) =>{
        this.clientId=client.sstRelationId!;
      })
      this.routerSubscription = this.router.events
        .pipe(filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
          this.handleUrlChange(event.urlAfterRedirects);
        });
    }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
    }
    if (this.incomeTaxEntitySubscription) {
      this.incomeTaxEntitySubscription.unsubscribe();
    }
    if (this.clientEntitySubscription) {
      this.clientEntitySubscription.unsubscribe();
    }
    if (this.isDefAangifteSubscription) {
      this.isDefAangifteSubscription.unsubscribe(); // Unsubscribe from income tax entity
    }
  }

  handleUrlChange(newUrl: string) {
    if (!this.isSaving && this.hasUnsavedChanges()) {
      this.isSaving = true;
      this.dataService.postIncomeTaxEntity(this.clientId, false, this.incomeTaxEntity);
      this.isSaving = false;
    }
  }

  private hasUnsavedChanges(): boolean {
    return this.rowTotaalFg.dirty
  }

    private updateForm(): void {
        // update opbrengsten
        let rowOpbrengstenLijst = this.aangifte?.box1?.resultaatUitOverigeWerkzaamheden?.rowOpbrengsten || [];
        this.partner.subscribe((partner) => {
            if (partner) {
                rowOpbrengstenLijst = this.aangifte?.partnerAangifte?.box1?.resultaatUitOverigeWerkzaamheden?.rowOpbrengsten || [];
            }
        });

        const formArray = this.rowTotaalFg.get('rowOpbrengsten') as FormArray;
        const focusedControl = this.focusedElementId ? document.getElementById(this.focusedElementId) as HTMLElement : null;
        while (formArray.length > rowOpbrengstenLijst.length) {
            formArray.removeAt(formArray.length - 1);
        }

        for (let i = 0; i < rowOpbrengstenLijst.length; i++) {
            if (i < formArray.length) {
                const control = formArray.at(i) as FormGroup;
                control.patchValue(rowOpbrengstenLijst[i]);
            } else {
                const formGroup = this.createRowGroup(rowOpbrengstenLijst[i]);
                formArray.push(formGroup);
            }
        }

        // update kosten
        let rowKostenLijst = this.aangifte?.box1?.resultaatUitOverigeWerkzaamheden?.rowKosten || [];
        this.partner.subscribe((partner) => {
            if (partner) {
                rowKostenLijst = this.aangifte?.partnerAangifte?.box1?.resultaatUitOverigeWerkzaamheden?.rowKosten || [];
            }
        });

        const formArrayKosten = this.rowTotaalFg.get('rowKosten') as FormArray;
        while (formArrayKosten.length > rowKostenLijst.length) {
            formArrayKosten.removeAt(formArrayKosten.length - 1);
        }

        for (let i = 0; i < rowKostenLijst.length; i++) {
            if (i < formArrayKosten.length) {
                const control = formArrayKosten.at(i) as FormGroup;
                control.patchValue(rowKostenLijst[i]);
            } else {
                const formGroupKosten = this.createRowGroupKosten(rowKostenLijst[i]);
                formArrayKosten.push(formGroupKosten);
            }
        }

        if (focusedControl && document.contains(focusedControl)) {
            focusedControl.focus();
        }
    }

    saveForm(): void {
        if (!this.partnerBoolean) {
            this.incomeTaxEntity.aangifte = {
                ...this.aangifte,
                box1: {
                    ...this.aangifte.box1,
                    resultaatUitOverigeWerkzaamheden: {
                        ...this.aangifte.box1?.resultaatUitOverigeWerkzaamheden,
                        rowKosten: this.rowTotaalFg.value.rowKosten,
                        rowOpbrengsten: this.rowTotaalFg.value.rowOpbrengsten
                    }
                }
            } as Aangifte;
            this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);

        } else {
            this.incomeTaxEntity.aangifte = {
                ...this.aangifte,
                partnerAangifte: {
                    ...this.aangifte.partnerAangifte,
                    box1: {
                        ...this.aangifte.partnerAangifte?.box1,
                        resultaatUitOverigeWerkzaamheden: {
                            ...this.aangifte.partnerAangifte?.box1?.resultaatUitOverigeWerkzaamheden,
                            rowKosten: this.rowTotaalFg.value.rowKosten,
                            rowOpbrengsten: this.rowTotaalFg.value.rowOpbrengsten
                        }
                    },
                },
            } as Aangifte;
            this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
        }
        this.rowTotaalFg.markAsDirty()
    }
}
